export const checkCacheReset = (config) => {
  try {
    if (config.method === "get") {
      const cacheReset = localStorage.getItem("ps-cache-reset");
      if (cacheReset) {
        config.headers = config.headers.concat({ "Cache-Control": "no-cache" });
        console.log("Cache Reset");
        const cacheResetParsed = JSON.parse(cacheReset);
        if (cacheResetParsed.time + 600000 < new Date().getTime()) {
          localStorage.removeItem("ps-cache-reset");
          console.log("Remove Cache Reset");
        }
      }
    }
  }
  catch { /* empty */ }
}

export const checkForCacheIssue = (response) => {
  try {
    if (response.status === 200 && response.config.method === "get" &&
      !response.request.responseURL.toLowerCase().endsWith(response.config.url.trim().toLowerCase())) {
      setCacheReset();
      console.log("Set Cache Reset");
    }
  }
  catch { /* empty */ }
}

export const setCacheReset = () => localStorage.setItem("ps-cache-reset", JSON.stringify({ time: new Date().getTime() }));